export const categoryViewStyles = {
  root: "flex-1 overflow-y-auto",
  header: "px-4 pb-2 pt-3",
  backBtn: "mb-3 flex items-center gap-1 text-xs text-subtle transition-colors hover:text-mid",
  backIcon: "h-3 w-3",
  title: "text-sm font-semibold text-foreground",
  description: "mt-0.5 text-xs text-subtle",
  divider: "mx-4 mb-3 mt-2 border-t border-muted",
  list: "flex flex-col gap-2 px-4 pb-3",
  promptBtn:
    "w-full rounded-xl border border-border bg-white px-3.5 py-2.5 text-left transition-colors hover:border-ring-border hover:bg-accent",
  promptInner: "flex items-start gap-2",
  promptIcon: "mt-0.5 shrink-0",
  promptLabel: "text-sm font-medium leading-snug text-foreground",
  hint: "px-4 pb-4 text-center text-xs text-subtle",
};
